import { getInitialState } from './state';

const mutations = {
  SET_PROFESSIONALIDENTIFICATION(state, professional) {
    state.professionalData = professional;
  },
  SET_CLEAR_PROFESSIONALIDENTIFICATION(state) {
    Object.assign(state, getInitialState());
  },
  SET_IS_ELEGIBLE_PROFESSIONAL_STEP(state, elegible) {
    state.isElegibleProfessionalStep = elegible;
  },
};

export default mutations;
